import {API_URL} from "../common/config";

export const API_LOGIN = "/auth/login/"
export const API_FILES = "/file/"
export const API_SLIP = "/slip/"
export const API_SLIP_DETAIL = "/slip/{0}/"
export const API_INVOICE = "/invoice/"
export const API_INVOICE_DETAIL = "/invoice/{0}/"
export const API_COMPANIES = "/company/"
export const API_COMPANIES_DETAIL = "/company/{0}/"
export const API_ANALYTICAL_ACCOUNTS = "/analyticalaccount/"
export const API_COMPANIES_ANALYTICAL_ACCOUNTS = "/company/{0}/analyticalaccount/"
export const API_COMPANIES_ANALYTICAL_ACCOUNTS_DETAIL = "/company/{0}/analyticalaccount/{1}/"
export const API_SECTIONS = "/section/"
export const API_SEGMENTS = "/segment/"
export const API_USERS = "/user/"
export const API_USER_PERMISSIONS = "/user/{0}/permission/"
export const API_USER_PERMISSIONS_DETAIL = "/user/{0}/permission/{1}/"
export const API_USER_PERMISSIONS_TYPES = "/user/{0}/permission-types/"
export const API_GROUPS = "/group/"
export const API_GROUPS_DETAIL = "/group/{0}/"
export const API_GROUP_PERMISSIONS = "/group/{0}/permission/"
export const API_GROUP_PERMISSIONS_DETAIL = "/group/{0}/permission/{1}/"
export const API_GROUP_PERMISSIONS_TYPES = "/group/{0}/permission-types/"
export const API_SIMPLE_FILES = "/simplefile/"

export const API_NOTIFICATIONS = "/notification/"
export const API_SEARCH = "/search/"
export const API_STATS = "/stats/"

export const API_ENUM_PERMISSIONS = "/enums/permissions/"
export const API_ENUM_VERSIONS = "/enums/versions/"
export const API_ENUM_STORAGES = "/enums/storages/"

export const DIRECT_AVATAR = API_URL + "/user/{0}/avatar"
